export default "__VITE_ASSET__DSkrzBZP__"